import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Lock } from "lucide-react";

interface GuestPromptDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const GuestPromptDialog = ({ open, onOpenChange }: GuestPromptDialogProps) => {
  const navigate = useNavigate();

  // Always routes in-app to login; the gate behind it (SubscriptionGate /
  // /subscribe) decides how to sell. The old PURCHASE_URL escape hatch — a
  // window.open to an external sales page — was permanently null, and wiring it
  // up would have been an App Store 3.1.1 (anti-steering) rejection on native.
  const handleCta = () => {
    onOpenChange(false);
    navigate("/login");
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent dir="rtl" className="max-w-sm">
        <AlertDialogHeader className="items-center text-center">
          <div className="mx-auto mb-2 h-12 w-12 rounded-full bg-primary/10 grid place-items-center">
            <Lock className="h-6 w-6 text-primary" />
          </div>
          <AlertDialogTitle className="text-center">
            רוצה להמשיך?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            התוכן הזה זמין למנויים. הירשמו כדי לגלות את כל מה שיש לנו להציע
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-col">
          <AlertDialogAction onClick={handleCta} className="w-full">
            הרשמה / התחברות
          </AlertDialogAction>
          <AlertDialogCancel className="w-full mt-0">
            אחר כך
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default GuestPromptDialog;
